import { render, staticRenderFns } from "./PersonListing.vue?vue&type=template&id=0b76d0e9&scoped=true"
import script from "./PersonListing.vue?vue&type=script&lang=js"
export * from "./PersonListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b76d0e9",
  null
  
)

export default component.exports